<template>
  <div class="chart-container ma-2" style="position: relative; height:30%; width:98%">
    <canvas ref="chartEl" width="98%" height="30%">
      <p>RSSI chart</p>
    </canvas>
  </div>
</template>
<script>
/* eslint-disable */
import Chart from 'chart.js';
import gql from 'graphql-tag';
import moment from 'moment';
import EventBus from '@/utils/EventBus';

const QUERY_WIFI_STATUS = gql`
query query_wifi_status($id: String!, $startTime: timestamptz!, $endTime: timestamptz!) {
  wifi_status (
    where: {
      _and: [
        {
          device_id: {
            _eq: $id
          }
        },
        {
          timestamp: {
            _gt: $startTime
          }
        },
        {
          timestamp: {
            _lt: $endTime
          }
        }
      ]
    }
    order_by: {
      timestamp: asc
    }
  ) {
    timestamp
    rssi
  }
}
`;
const SUBSCRIPTION_WIFI_STATUS = gql`
subscription subscription_wifi_status($id: String!, $timestamp: timestamptz) {
  wifi_status (
    where: {
      device_id: {
        _eq: $id
      }
      timestamp:{
        _gt: $timestamp
      }
    }
    order_by: {
      timestamp: desc
    }
    limit: 1
  ) {
    timestamp
    rssi
  }
}
`;

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      bandwith: [],
      chartUI: null,
      startTime: this.start,
      endTime: this.end,
      subscription: null,
      showNewValues: true,
    };
  },
  created() {
    EventBus.$on('monitoring-time-changed', this.reCreateChart);
  },
  beforeDestroy() {
    if (this.chartUI) {
      this.chartUI.destroy();
    }
    EventBus.$off('monitoring-time-changed', this.reCreateChart);
  },
  async mounted() {
    // wait for values
    await this.getBandwith();
    // create chartjs UI
    this.createChart();
    // subscribe to new values
    this.subcribeNewBandwith();
  },
  methods: {
    async reCreateChart(data) {
      this.startTime = data.startTime;
      this.endTime = data.endTime;
      // wait for values
      await this.getBandwith();
      // create chartjs UI
      if (this.chartUI) {
        this.chartUI.destroy();
      }
      this.createChart();
      /*
      if (data.subscribe) {
        console.log('show new values');
      } else {
        this.stopSubscription();
      }
      */
    },
    stopSubscription() {
      console.log('Don\'t show new values');
    },
    async getBandwith() {
      const result = await this.$apollo.query({
        query: QUERY_WIFI_STATUS,
        variables: {
          id: this.id,
          startTime: this.startTime,
          endTime: this.endTime,
        },
      });

      // create values for chartjs
      this.bandwith = result.data.wifi_status.map((data) => ({
        x: new Date(data.timestamp),
        y: (data.rssi),
      }));
    },
    createChart() {
      // create chartjs UI
      const config = {
        type: 'line',
        data: {
          datasets: [{
            backgroundColor: 'rgba(0,255,0,0.5)',
            borderColor: '#00ff00',
            fill: false,
            data: this.bandwith
          }]
        },
        options: {
          responsive: true,
          scales: {
            xAxes: [{
              gridLines: {
                color: 'rgba(150, 150, 150, 0.5)'
              },
              type: 'time',
              time: {
                tooltipFormat: 'YYYY-MM-DD HH:mm',
                displayFormats: {
                    millisecond: 'HH:mm:ss.SSS',
                    second: 'HH:mm:ss',
                    minute: 'HH:mm',
                    hour: 'HH'
                },
                unit: 'minute',
                stepSize: 30,
              },
            }],
            yAxes: [{
              gridLines: {
                color: 'rgba(150, 150, 150, 0.5)'
              },
              display: true,
              ticks: {
                beginAtZero: true,
              }
            }]
          },
          legend: {
            display: false,
          },
          title: {
            display: true,
            text: 'RSSI'
          }
        }
      };
      const { chartEl } = this.$refs;
      this.chartUI = new Chart(chartEl, config);
    },
    subcribeNewBandwith() {
      const { id } = this;
      const that = this;
      const timestamp = new Date().toISOString();

      // start subscribing to new values
      this.subscription = this.$apollo.subscribe({
        query: SUBSCRIPTION_WIFI_STATUS,
        variables: {
          id,
          timestamp
        },
      });
      this.subscription.subscribe({
          next(data) {
            // got new subscription result
            if (data.data.wifi_status.length > 0) {
              // Add new value to chart
              that.addData(data.data.wifi_status[0]);
            }
          },
          error(err) { console.error('err', err); },
      });
    },
    addData(data) {
      // create new value for chartjs
      const value = {
        x: new Date(data.timestamp),
        y: (data.rssi),
      };

      // Add chartjs data
      this.chartUI.data.labels.push(data.timestamp);
      this.chartUI.data.datasets.forEach((dataset) => {
        dataset.data.push(value);
      });

      // Update chartjs UI
      this.chartUI.update();
    },
  },
};
</script>
<style scoped>
</style>
